module.exports = __webpack_public_path__ + "static/media/ProcessAutomation-small-700x600.632691d9.jpg";